import {
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import IconButton from "@material-ui/core/IconButton";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import CloseIcon from "@material-ui/icons/Close";
import PropTypes from "prop-types";
import { supportEmail } from "../../consts/emails";
import { purchaseModalStyles } from "./purchase-modal.styles";

export const PurchaseModal = ({
  title,
  subtitle,
  isOpen,
  onClose,
  children,
}) => {
  const classes = purchaseModalStyles();

  if (!isOpen) {
    return null;
  }

  return (
    <Dialog
      data-testid="subscription-modal"
      className={classes.paymentModal}
      onClose={onClose}
      open={isOpen}
      maxWidth={"sm"}
    >
      <DialogTitle className={classes.dialogTitle}>
        <IconButton aria-label="close" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent className={classes.dialogContent}>
        <Grid container justifyContent="center">
          <Grid item xs={6} sm={12}>
            <Typography className={classes.title} align="center">
              {title}
            </Typography>
            {subtitle && (
              <Typography className={classes.subtitle} align="center">
                {subtitle}
              </Typography>
            )}
          </Grid>
          <Grid item className={classes.modalBody}>
            {children}
          </Grid>
          <Grid item className={classes.contactSupport}>
            <Typography align="center">Have questions?</Typography>
            <a href={supportEmail}>
              Contact support <ChevronRightIcon />
            </a>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

PurchaseModal.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
